import FnbPOS from "./FnbPOS";
export default function FnbPoolPage() {
  return <FnbPOS serviceKind="pool" showTables={false} showRoomInput testidPrefix="pool"/>;
}
